import { getJson } from 'api/baseApi'

export const loadChildrenFolders = function (parentId) {
  return getJson({ url: `/api/server/folders/subfolders/${parentId}` })
}

export const loadRootName = function () {
  return getJson({ url: `/api/server/folders/GetRootName` })
}



// WEBPACK FOOTER //
// ./src/api/treeviewOldApi.js